import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export const selectIsAccountClosed = createSelector(selectBase, base => {
  return base.state === 'closed'
})
